// import Swiper JS
import $ from "jquery";
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

// Select all elements with the class 'currentdev_scroll'
var sliders = document.querySelectorAll('.currentdev_scroll');

// Loop through each slider element
sliders.forEach(function(slider) {
  // Initialize Swiper for this slider
  var cardSlider = new Swiper(slider, {
    slidesPerView: 1.25,
    spaceBetween: 15,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      snapOnRelease:true,
      draggable:true
    },
    breakpoints: {
      700: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
  });
});
